import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import moment from 'moment-timezone';
import { Icon } from 'front-onceforall-core';
import Tooltip from '@material-ui/core/Tooltip';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const RequestInformationView = props => {
  const formatAmount = amount => {
    const formatter = new Intl.NumberFormat('fr-EU', {
      style: 'currency',
      currency: 'EUR'
    });
    return formatter.format(amount);
  };
  let editButton = /*#__PURE__*/_jsx("button", {
    "data-id": "edit",
    className: "large secondary inline-container",
    onClick: props.onEditButtonClick,
    disabled: !props.isEditable,
    style: props.isEditable ? {} : {
      pointerEvents: 'none'
    },
    children: /*#__PURE__*/_jsx(Icon, {
      icon: "edit"
    })
  });
  editButton = props.isEditable ? editButton : /*#__PURE__*/_jsx(Tooltip, {
    "data-id": "edit-disabled-tooltip",
    title: /*#__PURE__*/_jsx(Translate, {
      value: 'request.page.buttonsDisabledTooltip'
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: editButton
    })
  });
  let paymasterTranslateValue = 'request.page.paymaster';
  if (!props.isPaymasterRequestOwner) {
    paymasterTranslateValue = props.payMasterOrganisationName ? 'request.page.paymasterKnownClient' : 'request.page.paymasterUnknownClient';
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h2", {
      className: "no-wrap",
      children: /*#__PURE__*/_jsx(Translate, {
        value: "request.page.details"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "card pt-0",
      children: props.error ? /*#__PURE__*/_jsx("span", {
        "data-id": "error-message",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "error.generic"
        })
      }) : props.loading ? /*#__PURE__*/_jsx("span", {
        className: "loading-overlay"
      }) : props.request && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "box border bottom",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex-container space-between",
            children: [/*#__PURE__*/_jsx("div", {
              className: "card-header font-size-l",
              children: /*#__PURE__*/_jsx(Translate, {
                value: "address.addressLine"
              })
            }), props.showOwnerButtons && editButton]
          }), /*#__PURE__*/_jsxs("div", {
            className: "information",
            children: [`${props.request.project.address.addressLine},`, /*#__PURE__*/_jsx("br", {}), `${props.request.project.address.postCode} ${props.request.project.address.city}`]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "box border bottom",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-l",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "request.page.creationDate"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: moment(props.request.creationDate).format('L')
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "box border bottom",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-l",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "request.page.estimatedDatesTitle"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "request.page.estimatedDates",
              dateStart: moment(props.request.startingDate).format('L'),
              dateEnd: moment(props.request.endingDate).format('L')
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "box border bottom",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-l",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "request.page.serviceProvision"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: props.request.details
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "box border bottom",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-l",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "request.page.amount"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information mb-4",
            children: formatAmount(props.request.amount)
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: /*#__PURE__*/_jsx(Translate, {
              "data-id": "paymasterName",
              value: paymasterTranslateValue,
              paymasterName: props.payMasterOrganisationName
            })
          })]
        })]
      })
    })]
  });
};
RequestInformationView.defaultProps = {
  loading: true,
  error: false,
  isEditable: false,
  showOwnerButtons: false
};
RequestInformationView.propTypes = {
  request: PropTypes.object,
  isEditable: PropTypes.bool,
  showOwnerButtons: PropTypes.bool,
  payMasterOrganisationName: PropTypes.string,
  isPaymasterRequestOwner: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onEditButtonClick: PropTypes.func
};
export default RequestInformationView;